import { useState } from "react";

/**
 * useErrorMessage - Simple error message hook that stores your error text, manages timeout
 * @param {Number} messageLength - The time until the message disappears
 */
const useErrorMessage = (messageLength = 4000) => {
  const [error, setError] = useState(null);
  const [timeoutID, setTimeoutID] = useState(null);

  const setErrorMessage = (newErrorMessage) => {
    if (timeoutID) {
      clearTimeout(timeoutID);
      setTimeoutID(null);
    }

    const newTimeoutID = setTimeout(() => {
      setError(null);
      setTimeoutID(null);
    }, messageLength);

    setTimeoutID(newTimeoutID);
    setError(newErrorMessage);
  };

  const clearError = () => {
    if (!timeoutID) return;

    clearTimeout(timeoutID);
    setTimeoutID(null);
    setErrorMessage(null);
  };

  return { error, setError: setErrorMessage, clearError };
};

export default useErrorMessage;
